<template>
  <div class="app-container">
    <list ref="list" @change="onChange">
      <template slot="toolbar-right" v-if="$permission.canRead()">
          <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <!-- <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
      </template> -->
    </list>
    <!-- <div class="list-head" style="margin-top: 10px;">
      <span>明细信息</span>
    </div>
    <el-table :data="Details" border v-loading="loading" show-summary>
      <template>
        <el-table-column prop label="单据类型" align="center" />
        <el-table-column prop label="单据编号" align="center" />
        <el-table-column prop label="业务类型" align="center" />
        <el-table-column prop label="单据日期" align="center" />
        <el-table-column prop label="明细" align="center" />
        <el-table-column prop label="计量单位" align="center" />
        <el-table-column prop label="数量" align="center" />
        <el-table-column prop label="含税单价" align="center" />
        <el-table-column prop label="应收" align="center" />
        <el-table-column prop label="已收" align="center" />
        <el-table-column prop label="应收转让" align="center" />
        <el-table-column prop label="应付" align="center" />
        <el-table-column prop label="已付" align="center" />
        <el-table-column prop label="应付转让" align="center" />
        <el-table-column prop label="余额" align="center" />
      </template>
    </el-table> -->
    <check-dialog ref="checkDialog" @confirm="confirm" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/finance/dealings/supplierbill/list";
import checkDialog from "@/components/finance/dealings/supplierbill/checkDialog";

export default {
  name: "supplierbill",
  mixins: [curdMixins],
  components: {
    list,
    checkDialog,
  },
  data() {
    return {
      // api,
      Details: [],
      loading: false,
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    onChange(row) {
      // console.log("选中行", JSON.parse(JSON.stringify(row)));
      // this.Details = [];
      // this.api.list({ Id: row.OtherReceivId }).then((res) => {
      //   if (res.Code == 0) this.Details = res.Data;
      // });
    },
    create() {
      this.$refs.checkDialog.open();
    },
    confirm(data) {
      console.log("筛选", data);
    },
  },
};
</script>